module.exports = __webpack_public_path__ + "dimer/static/img/aboutImg1.dd84f24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutImg1.jpg
// module id = A+GU
// module chunks = 0